module.exports = __webpack_public_path__ + "workspace/static/img/datto_autotask.ffdaeaa.png";